import ApiService from '../apiservice'

export default class MgmtService extends ApiService {
    constructor() {
        super('');
    }

    getClients() {
        return this.get('/mgmt/clients');
    }

    createClient(data) {
        return this.post('/mgmt/client/create', data, 1);
    }

    updateClient(data) {
        return this.post('/mgmt/client/update', data, 1);
    }

    deleteClient() {
        return this.post('/mgmt/client/delete');
    }

    getLogins() {
        return this.get('/mgmt/logins');
    }

    createLogin(data) {
        return this.post('/mgmt/login/create', data, 1);
    }

    updateLogin() {
        return this.post('/mgmt/login/create');
    }

    deleteLogin() {
        return this.post('/mgmt/login/create');
    }

    getPlates() {
        return this.get('/mgmt/plates');
    }

    getPlatesByClient(client) {
        return this.get('/mgmt/platesByClient', client);
    }

    createPlate(data) {
        return this.post('/mgmt/plate/create', data, 1);
    }

    updatePlate(data) {
        return this.post('/mgmt/plate/update', data, 1);
    }

    deletePlate() {
        return this.post('/mgmt/plate/create');
    }

    updateLogpointer() {
        return this.post('/mgmt/logpointer/create');
    }

    restartPositionLogpointer() {
        return this.post('/mgmt/logpointer/restartposition');
    }

    updateHorimeter(data) {
        return this.post('/mgmt/updateHorimeter', data, 1);
    }

    getHorimeterHistory(data) {
        return this.get('/mgmt/historyHorimeter', data);
    }

    getPositions(startDate, endDate, plate, pageSize, pageIndex) {

        return this.get('/mgmt/reports/positions', {
            "startDate": startDate,
            "endDate": endDate,
            "plate": plate,
            "pageSize": pageSize,
            "pageIndex": pageIndex
        });
    }

    getCommands(data) {
        return this.get('/mgmt/reports/commands', data);
    }
}